/* Fixed links and assets for the "individuelles Design" CTA on the templates page. */

import customDesignSampleMockupImg from '#assets/images/mockup-custom-pdfs.jpg';
import a4LetterMeasurementsPdf from '#assets/pdfs/b2bhero-a4-letter-measurements.pdf';

// Calendly/Pipedrive scheduler for the B2B Hero intro call.
export const CUSTOM_DESIGN_BOOKING_URL =
	'https://b2b-hero.pipedrive.com/scheduler/kWo83zCz/einfuhrungsgesprach-b2b-hero';

// Illustration shown next to the CTA copy.
export const CUSTOM_DESIGN_IMAGE_URL = customDesignSampleMockupImg;

// Reference PDF showing the correct A4 letter layout (address window, safe margins, fold marks).
// Shown in the PDF-upload setup as guidance for how a print-ready A4 letter should look.
export const A4_LETTER_MEASUREMENTS_PDF_URL = a4LetterMeasurementsPdf;
